import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Rating,
  TextField,
  Typography,
  Box,
  Alert,
  CircularProgress
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import reviewService from '../../services/reviewService'; // Hozzáadva
import RateReviewIcon from '@mui/icons-material/RateReview';
import DialogHeader from '../Common/DialogHeader';

const WriteReview = ({ open, onClose, providerId, bookingId, onReviewSubmitted }) => {
  const { isAuthenticated, user, isClient } = useAuth();
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (open) {
      setRating(0);
      setComment('');
      setError(null);
      setSuccess(false);
    }
  }, [open]);

  const handleSubmit = async () => {
    if (!isAuthenticated || !isClient()) {
      setError('Csak bejelentkezett ügyfelek írhatnak értékelést.');
      return;
    }
    if (rating === 0) {
      setError('Kérjük, adjon csillagot az értékeléshez.');
      return;
    }
    if (comment.trim().length < 10) {
      setError('Kérjük, írjon legalább 10 karakter hosszú véleményt.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const reviewData = {
        providerId: parseInt(providerId),
        rating: rating,
        comment: comment.trim(),
        // bookingId: bookingId ? parseInt(bookingId) : undefined, // Ha van bookingId
      };

      const response = await reviewService.submitReview(reviewData);

      if (response.success) {
        setSuccess(true);
        onReviewSubmitted(response.data.review); // Visszaadjuk az új értékelést
        setTimeout(() => {
          onClose();
        }, 1500);
      } else {
        throw new Error(response.message || 'Értékelés elküldése sikertelen.');
      }
    } catch (err) {
      console.error('Értékelés elküldése hiba:', err);
      setError(err.message || 'Értékelés elküldése sikertelen.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ p: 0 }}>
        <DialogHeader icon={<RateReviewIcon />} title="Értékelés írása" onClose={onClose} />
      </DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
            {error}
          </Alert>
        )}
        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            Értékelés sikeresen elküldve! Jóváhagyás után megjelenik.
          </Alert>
        )}

        <Box sx={{ mb: 2 }}>
          <Typography component="legend">Az Ön értékelése</Typography>
          <Rating
            name="simple-controlled"
            value={rating}
            onChange={(event, newValue) => {
              setRating(newValue);
            }}
            size="large"
            disabled={loading}
          />
        </Box>
        <TextField
          autoFocus
          margin="dense"
          label="Véleménye"
          type="text"
          fullWidth
          multiline
          rows={4}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          disabled={loading}
          placeholder="Ossza meg tapasztalatait a szolgáltatóval kapcsolatban..."
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2.5, gap: 1, borderTop: '1px solid', borderTopColor: 'divider' }}>
        <Button onClick={onClose} disabled={loading}>
          Mégse
        </Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : 'Elküldés'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WriteReview;